import Component from './Component';
import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/modern/theme'

// PLUGINS
import 'tinymce/plugins/lists/plugin'
import 'tinymce/plugins/advlist/plugin'

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */



/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */







/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export default class Wysiwyg extends Component {

    decorator () {
        return {
            selector : '.js-wysiwyg',
            name : 'Wysiwyg',
        }
    }


    constructor(element) {
        super(element);

        tinymce.init({
            selector: this.selector,
            theme: 'modern',
            skin_url: '/skins/lightgray',
            plugins: ['lists', 'advlist'],
            advlist_bullet_styles: 'disc',
            advlist_number_styles: 'default',
            menubar: false,
            resize: false,
            toolbar: 'numlist bullist',
            branding: false,
            elementpath: false,
            content_css: '/css/editor-style.css',
            setup: editor => {
                editor.addMenuItem('myItem', {
                    text: 'List Item',
                    context: 'Test'
                });

                editor.on('keyup', e => {
                    editor.getContentAreaContainer().parentElement.parentElement.nextSibling.value = editor.getContent();
                });

                editor.on('nodeChange', e => {
                    editor.getContentAreaContainer().parentElement.parentElement.nextSibling.value = editor.getContent();
                });
            }
        });
    }

}
